import axiosInstance from '../api/axiosInstance';

/**
 * customerService — All Customer API calls
 *
 *  GET    /Customers         → list all customers
 *  POST   /Customers         → create a customer
 *  PUT    /Customers/{id}    → update a customer
 *  DELETE /Customers/{id}    → delete a customer
 */

// Get all customers (supports optional query params like search, page, etc.)
export const getCustomers = (params) => {
  return axiosInstance.get('/Customers', { params }).then((res) => res.data);
};

// Get a single customer by ID
export const getCustomer = (id) => {
  return axiosInstance.get(`/Customers/${id}`).then((res) => res.data);
};

// Create a new customer
export const createCustomer = (data) => {
  return axiosInstance.post('/Customers', data).then((res) => res.data);
};

// Update an existing customer
export const updateCustomer = (id, data) => {
  return axiosInstance.put(`/Customers/${id}`, data).then((res) => res.data);
};

// Delete a customer
export const deleteCustomer = (id) => {
  return axiosInstance.delete(`/Customers/${id}`).then((res) => res.data);
};
